<template>
    <div class="google_map">
        <v-container
         :fluid="true"
        >
        <GmapMap 
         :center="{lat:10,lng:10}"
         :zoom="7"
         style="height: 500px;width: 100%;"
         >
        </GmapMap>
        </v-container>
    </div>
</template>

<script>
export default {
    name:'google_map',
    data() {
        return {
            coordinates:{
                lat:0,
                lng:0
            }
        }
    },
    created(){
        this.$getLocation({})
         .then(coordinates=>{
             this.coordinates=coordinates
         })
         .catch(error=>alert(error));
    }
}
</script>